import EntityModel from '@/common/models/entity-model';
import timezone from '@/common/timezone';

export default class DisputeModel extends EntityModel {
    hydrate({
        id = null,
        transactionId = null,
        currency = null,
        amount = null,
        acquirerReferenceNumber = null,
        reasonCode = null,
        type = 'first-chargeback',
        status = null,
        postedTime = null,
        deadlineTime = null,
    } = {}) {
        this.id = id;
        this.transactionId = transactionId;
        this.currency = currency;
        this.amount = Number(amount);
        this.acquirerReferenceNumber = acquirerReferenceNumber;
        this.reasonCode = reasonCode;
        this.type = type;
        this.status = status;
        this.postedTime = postedTime || timezone.getUTC().format();
        this.deadlineTime = deadlineTime;
    }

    getPayload() {
        return {
            transactionId: this.transactionId,
            currency: this.currency,
            amount: this.amount,
            acquirerReferenceNumber: this.acquirerReferenceNumber,
            reasonCode: this.reasonCode,
            type: this.type,
            status: this.status,
            postedTime: this.postedTime,
            deadlineTime: this.deadlineTime,
        };
    }
}
